// Copyright (c) 2018 Deere & Company

import _ from 'lodash';

const getAvailableItems = (availableColumns, selectedColumns) =>
    _.differenceBy(availableColumns, selectedColumns, 'id');

export default getAvailableItems;



// WEBPACK FOOTER //
// ./src/shared/components/excel-layout/services/get-available-items.js